// 申请人批量验收
import React from 'react'
import { connect } from 'react-redux'
import { getListItems, getFormValue, nullDate, TDate } from '../../public/utility'
import { getListIds, changeListItem, hasChangedValues } from '../../public/utility'

class ApplicantBatchAcceptanceDiv extends React.Component {
    state = {
        changedValues基本信息: {}
    }

    componentDidMount = () => {
        this.handelGetAcceptance()
    }

    handelGetAcceptance = () => {
        const { list, type } = this.props
        Tyan.doPostEvent('GetApplicantAcceptance', {
            data: { list },
            onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                else {
                    this.setState({ initValues基本信息, changedValues基本信息: {}, optionsParas })
                    // const { list } = getListItems(this, '基本信息', '待验收列表')
                    // if (type == '验收')
                    //     list.forEach(o =>
                    //         changeListItem(this, { 验收数量: o.数量 }, {}, '基本信息', '待验收列表', o.id)
                    //     )
                }
            }
        })
    }

    handlerAssignInspectors = () => {
        const { onSave, onClose, type } = this.props
        const { changedValues基本信息 } = this.state
        const { list } = getListItems(this, '基本信息', '待验收列表')
        if (type == "验收") {
            if (list.filter(o => !(o.验收数量 && o.收货仓库)).length > 0) {
                Ext.toast('验收数量和收货仓库不能为空')
                return
            }
            if (list.filter(o => o.验收数量 > o.数量).length > 0) {
                Ext.toast('验收数量大于库存数量')
                return
            }
        }
        else {
            if (list.filter(o => !o.不予验收数量).length > 0) {
                Ext.toast('不予验收数量不能为空')
                return
            }
            if (list.filter(o => o.不予验收数量 > o.数量).length > 0) {
                Ext.toast('不予验收数量大于库存数量')
                return
            }
        }
        Tyan.doPostEvent('BatchApplicantAcceptance', {
            data: { changedValues基本信息, type },
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    Ext.toast('操作成功')
                    onSave && onSave()
                    onClose && onClose()
                }
            }
        })
    }
    bChanged = () => {
        const { list } = getListItems(this, '基本信息', '待验收列表')
        return list.filter(o => !o.附件).length == 0
    }

    handlerClose = () => {
        const { onClose } = this.props
        onClose && onClose()
    }

    canSave = () => {
        const { type } = this.props
        const { list } = getListItems(this, '基本信息', '待验收列表')
        return hasChangedValues(this)
        // if (type == '验收') {
        //     return list.filter(o => !o.收货仓库 || o.验收数量 > o.数量 || (!o.附件 || o.附件.length == 0)).length == 0
        // }
        // else
        //     return list.filter(o => !o.不予验收数量 || o.不予验收数量 > o.数量 || !o.附件).length == 0
    }

    fieldset基本信息 = () => {
        const { type } = this.props
        const { list } = getListItems(this, '基本信息', '待验收列表')
        const { changedValues基本信息 } = this.state
        const p = { margin: '5px 15px 5px 15px', minWidth: 50, _full: true, flex: 1 }
        return [].concat([{
            _group: '', padding: '0 10 0 0', minWidth: '90%', items: [
                { _label: '物料代码', ...p, },
                { _label: '物料名称', ...p, },
                { _label: '规格型号', ...p, },
                { _label: '单位', ...p, },
                { _label: '数量', ...p, },
                { _label: '验收数量<font style=\'color:red\'>*</font>', ...p, cdt: () => type == '验收' },
                { _label: '收货仓库<font style=\'color:red\'>*</font>', ...p, cdt: () => type == '验收' },
                { _label: '不予验收数量<font style=\'color:red\'>*</font>', ...p, cdt: () => type == '不予验收' },
                { _label: '原因', ...p, cdt: () => type == '不予验收' },
                { _label: '', ...p, cdt: () => type == '验收', minWidth: 300, margin: '5px 15px 5px 15px', _full: true, flex: 1 },
            ]
        }]).concat([{
            _group: '', margin: '0', items: list.map(o => ({
                _group: '', padding: '0 10 0 0', list: { listName: '待验收列表', id: o.id }, minWidth: '90%', items: [
                    { _text: '', name: '物料代码', disabled: true, ...p, },
                    { _text: '', name: '物料名称', disabled: true, ...p, },
                    { _text: '', name: '规格型号', disabled: true, ...p, },
                    { _text: '', name: '单位', disabled: true, ...p, },
                    { _float: '', name: '数量', disabled: true, ...p, },
                    { _float: '', name: '验收数量', ...p, cdt: () => type == '验收', maxValue: o.数量 },
                    { _select: '', name: '收货仓库', ...p, optionName: '收货仓库', cdt: () => type == '验收' },
                    { _float: '', name: '不予验收数量', ...p, cdt: () => type == '不予验收', maxValue: o.数量 },
                    { _text: '', name: '原因', ...p, cdt: () => type == '不予验收' },
                    { _files: '', name: '附件', cdt: () => type == '验收', minWidth: 300, margin: '5px 15px 5px 15px', _full: true, flex: 1 },
                ]
            }))
        }])
    }

    render() {
        const { showBody: Body, showMessage: Message, } = this.props
        const { initValues基本信息 } = this.state
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        const canSave = this.canSave()
        const bChanged = this.bChanged()
        return <Body data={this} maxWidth="1500"
            controls={
                [
                    { _button: '确定', icon: 'save', handler: this.handlerAssignInspectors, disabled: !canSave },
                    { _button: '关闭', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息() },
                ]}
        />
    }
}

export default connect()(ApplicantBatchAcceptanceDiv)